export default "__VITE_ASSET__2c8f0283__"